import { type Ref, ref, watch } from 'vue'
import { useLoadControlMeter } from '@/widgets/CabinetMeterItem/model/api'
import type { CabinetMeterType } from '@/widgets/CabinetMeterItem/model/types'
import type { MeterLimitsType } from '@/entities/Meters'

const useModel = () => {
  const meter = ref<CabinetMeterType | null>(null)
  const limits = ref<MeterLimitsType | null>(null)
  const contactorStatus = ref(true)
  const isMonitoring = ref(true)
  const isSummaryLimits = ref(true)

  /**
   * Функция загрузки и установки данных счетчика
   * @param meter_id
   */
  const loadData = (meter_id: Ref<number>) => {
    const result = useLoadControlMeter(meter_id)

    watch(result.data, () => {
      if (result.data.value) {
        meter.value = result.data.value.data
        limits.value = result.data.value.payload.cabinet_limits
        contactorStatus.value = result.data.value.payload.contactros_status
        isMonitoring.value =
          result.data.value.payload.ui_monitoring_enabled &&
          result.data.value.data.order_number == result.data.value.payload.meter_order_number
        isSummaryLimits.value = result.data.value.payload.check_summary_limits
      }
    })

    return result
  }

  return {
    meter,
    limits,
    contactorStatus,
    isMonitoring,
    isSummaryLimits,

    loadData,
  }
}

export default useModel
